import { defineEvent, defineStore } from "@otto-ec/global-resources/nexus";
import type { AsyncNamespaceInput } from "@otto-ec/global-resources/nexus";
import { delegate } from "@otto-ec/global-resources/event";
import * as getters from "./apis/getters.js";
import type { OcSheetV1CurrentState } from "./index.js";
import { sheetGoBack, sheetOpenById, sheetClose, sheetCreate } from "./apis/methods.js";
import { findInstance } from "./stack/stack.utils.js";
import { stack } from "./stack/stack.global.svelte.js";
import {
  DATA_SELECTORS,
  EVENT_CLICK,
  handleCloseOnClick,
  handleCreateOnClick,
  handleOpenOnClick,
} from "./apis/convenience.js";

/*                                                                               */
export const sheetV1: AsyncNamespaceInput<OttoComponentApi["sheetV1"]> = {
  current: defineStore<OcSheetV1CurrentState>({
    id: null,
    instance: null,
    isActive: false,
    action: null,
    reason: null,
    length: 0,
  }),

  open: sheetOpenById,
  close: sheetClose,
  back: sheetGoBack,
  create: sheetCreate,

  events: {
    beforeOpen: defineEvent(),
    open: defineEvent(),
    flyin: defineEvent(),
    afterOpen: defineEvent(),

    beforeClose: defineEvent(),
    flyout: defineEvent(),
    close: defineEvent(),
    afterClose: defineEvent(),

    contentFetch: defineEvent(),
    contentParse: defineEvent(),
    contentApply: defineEvent(),
    contentDiscard: defineEvent(),
    contentError: defineEvent(),

    presentationEnd: defineEvent(),
    presentationStart: defineEvent(),

    /*                              */
    ...({
      beforeContentChange: defineEvent(),
      contentChangeShow: defineEvent(),
      contentChangeHide: defineEvent(),

      contentLoaded: defineEvent(),
      contentLoadingError: defineEvent(),
      /*                                                               */
    } as {}),
  },

  /*                     */
  getOpenSheet: () => findInstance(stack.current),
  getContent: () => getters.getContent(findInstance(stack.current)),
  getHeader: () => getters.getHeader(findInstance(stack.current)),
  getActions: () => getters.getActions(findInstance(stack.current)),
};

/*                                                              */
/*                                                                                                      */
delegate(window.document, EVENT_CLICK, DATA_SELECTORS[0], handleOpenOnClick);
delegate(window.document, EVENT_CLICK, DATA_SELECTORS[2], handleOpenOnClick);
delegate(window.document, EVENT_CLICK, DATA_SELECTORS[1], handleCreateOnClick);
delegate(window.document, EVENT_CLICK, DATA_SELECTORS[3], handleCloseOnClick);
